import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";

export const scenarioMasterService = createApi({
  reducerPath: "scenarioMasterService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["scenarioMaster"],
  endpoints: (builder) => ({
    getAllScenarioMasters: builder.mutation({
      query: (body) => ({
        url: `${userManagement.scenarioMasterController.getAllScenarioMaster}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    searchScenarioMasters: builder.mutation({
      query: (body) => ({
        url: userManagement.scenarioMasterController.searchScenarioMaster,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    getScenarioMasterById: builder.mutation({
      query: (body) => ({
        url: `${userManagement.scenarioMasterController.getScenarioMasterById}/${body.id}`,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    saveScenarioMaster: builder.mutation({
      query: (body) => ({
        url: userManagement.scenarioMasterController.saveScenarioMaster,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    updateScenarioMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.scenarioMasterController.updateScenarioMaster}/${body.id}`,
        method: "PUT",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    deleteScenarioMaster: builder.mutation({
      query: (body) => ({
        url: `${userManagement.scenarioMasterController.deleteScenarioMaster}/${body.id}`,
        method: "DELETE",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    findAllScenarioMasters: builder.mutation({
      query: (body) => ({
        url: userManagement.scenarioMasterController.findAllScenarioMaster,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    bulkUploadScenarioMasters: builder.mutation({
      query: (body) => ({
        url: userManagement.scenarioMasterController.bulkUploadScenarioMaster,
        method: "POST",
        body: body.payload,
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
    getAllReligions: builder.mutation({
      query: (body) => ({
        url: userManagement.scenarioMasterController.getAllReligions,
        method: "GET",
        headers: { Authorization: `Bearer ${body.token}` },
      }),
    }),
  }),
});

export const {
  useGetAllScenarioMastersMutation,
  useSearchScenarioMastersMutation,
  useGetScenarioMasterByIdMutation,
  useSaveScenarioMasterMutation,
  useUpdateScenarioMasterMutation,
  useDeleteScenarioMasterMutation,
  useFindAllScenarioMastersMutation,
  useBulkUploadScenarioMastersMutation,
  useGetAllReligionsMutation
} = scenarioMasterService;
